import { removeCacheCoupons } from '../config';
import { productStoreApi } from '../entry';
import { KonakartService } from '../services/konakart';
import { couponStoreApi } from '../store/couponStore';
import { useOrderStore } from '../store/orderStore';
import { T_Coupon, T_OrderRequest } from '../types';
import { parseQuery } from './parseQuery';
import { useFreeProduct } from './useFreeProduct';

/**
 * For all subsequent calls other than the first updateOrder/updateCampaignOrder on load.
 * This also ensures the free product toast is called after each order
 * @param konakartService
 */
function useUpdateCart(konakartService: KonakartService, checkFreeProduct: boolean = true) {
  const { updateOrderMethod } = useOrderStore(s => ({
    updateOrderMethod: s.updateOrder,
  }));
  const { toggleCheckFreeProduct } = useFreeProduct(konakartService);

  const queries: any = parseQuery(location.search);
  if (queries?.couponCode) {
    const queryCoupon = couponStoreApi
      ?.getState()
      ?.coupons?.filter(cp => !queries?.couponCode?.split(',')?.includes(cp.couponCode));
    queryCoupon.forEach(cp => {
      couponStoreApi?.getState()?.clearCouponFromCode(cp.couponCode);
    });
  }

  const updateOrder = async (customerId: string, products: T_OrderRequest[]) => {
    await updateOrderMethod(
      konakartService,
      customerId,
      products,
      couponStoreApi.getState()?.coupons,
      undefined,
      couponStoreApi.getState()?.ctCoupons,
      productStoreApi.getState()?.products
    ).then(() => {
      if (checkFreeProduct) {
        toggleCheckFreeProduct();
      }
    });
  };

  return { updateOrder };
}

export { useUpdateCart };
